<!--
<button *ngIf="isDevModeCustom()" style="height: 300px" (click)="triggerGenerateFileTree()">GENERATE MEDIA FILTREE</button>
-->
<main div fxLayout="row" fxLayoutAlign="start start">

  <app-treefile [(latestUpdate)]="latestUpdate" class="main-element" (selectedFolder)="setSelectedFolder($event)" (moduleIdOut)="setModuleId($event)"
                (uploadFiles)="onChange($event)" (importElementEvent)="refreshDataFromServer()"></app-treefile>


  <div class="contentWrapper main-element" fxLayout="column" fxLayoutAlign="start start">
    <ng-container>
    <!--  <div *ngIf="selectedFolder == 'root' || selectedFolder == null">
        <button [disabled]="restraintAccess()" class="card-button" mat-flat-button color="accent" (click)="applyToAllDeviceFromGroup()">{{'applyToAll' | translation}}</button>
      </div>-->
      <div *ngIf="selectedFolder == 'root' || selectedFolder == null">
        <!-- [disabled]="restraintAccess()" -->
        <button class="card-button" mat-flat-button color="accent" (click)="applyToSelectedDevice()">{{'applyToDevice' | translation}}</button>
      </div>

      <div class="backUpContainer" *ngIf="selectedFolder == 'root' || selectedFolder == null">
        <button [disabled]="restraintAccess()" class="card-button" mat-flat-button color="accent" (click)="saveMediaBackup()" >{{'mediaBackupSave' | translation}}</button>
        <p *ngIf="backupData">{{'latestBackupDate' | translation}}: {{backupData.latestBackup | date:'short'}}</p>

        <button [disabled]="restraintAccess()" *ngIf="backupData" class="card-button" mat-flat-button color="accent" (click)="loadMediaBackup()" disabled>{{'mediaBackupLoad' | translation}}</button>
      </div>
    </ng-container>








    <section fxLayout="column">

      <div fxLayout="row ">
        <div class="nav-title">
          <h1 *ngIf="pathDisplay.length <= 0">{{'home' | translation}} > {{ pathDisplay }}</h1>
          <h1 *ngIf="pathDisplay.length > 0">{{ pathDisplay }}</h1>
        </div>
        <!-- <p>Dossier</p> -->
      </div>
      <mat-accordion>
        <mat-expansion-panel *ngIf="selectedFolder.id == undefined">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{'globalMediaDesign' | translation}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div fxLayout="column">


            <div class="design-media-container" *ngIf="selectedFolder.id == undefined">
              <div class="nav-title">
                <h1>{{'buttonDesign' | translation}}</h1>
              </div>

              <div fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout="column" fxLayoutAlign="center center" class="displayWrapper">
                  <div fxLayout="column" fxLayoutAlign="center center" class="image-upload-wrapper">
                    <h2>{{'full' | translation}}</h2>
                    <span *ngIf="!loadingBackgroundThumbnail" class="spinner">

                      <mat-spinner [diameter]="36"></mat-spinner>
                    </span>


                    <!--
              ALTERNATIVE DESIGN
          <img class="templateStyle" src="assets/img/FULL.svg" />-->
                    <!--<div >

          <img (load)="onLoadImg('backgroundThumbnail', $event)" (error)="onErrorImg('backgroundThumbnail', $event)" id="backgroundThumbnail" #backgroundThumbnail [src]="folderBackgroundAssetsUrl" alt="Aucune image" />
                </div>-->
                    <div class="empty-image-bg">
                      <img src="assets/img/FULL.svg" />
                    </div>
                    <mat-radio-group name="mediaStyle">
                      <mat-radio-button value="full" [checked]="mediaStyle == 'full'" (change)="setStyle('full')">
                      </mat-radio-button>

                    </mat-radio-group>



                  </div>
                  <p>{{'thumbnailSize' | translation}}</p>
                  <p>300x200px</p>
                </div>
                <div fxLayout="column" fxLayoutAlign="center center" class="displayWrapper">
                  <div fxLayout="column" fxLayoutAlign="center center" class="image-upload-wrapper">
                    <h2>{{'minimal' |translation}}</h2>
                    <span *ngIf="!loadingBackgroundThumbnail" class="spinner">

                      <mat-spinner [diameter]="36"></mat-spinner>
                    </span>

                    <div class="empty-image-bg">
                      <img src="assets/img/COMPACT.svg" />
                      <!--<img (load)="onLoadImg('backgroundThumbnail', $event)" (error)="onErrorImg('backgroundThumbnail', $event)" id="backgroundThumbnail" #backgroundThumbnail [src]="folderBackgroundAssetsUrl" alt="Aucune image" />-->
                    </div>
                    <mat-radio-group name="mediaStyle">
                      <mat-radio-button value="minimale" [checked]="mediaStyle == 'minimal'" (change)="setStyle('minimal')">
                      </mat-radio-button>
                    </mat-radio-group>

                  </div>
                  <p>{{'thumbnailSize' | translation}}</p>
                  <p>300x200px</p>
                </div>
                <div fxLayout="column" fxLayoutAlign="center center" class="displayWrapper">
                  <div fxLayout="column" fxLayoutAlign="center center" class="image-upload-wrapper">
                    <h2>{{'image' | translation}}</h2>
                    <span *ngIf="!loadingBackgroundThumbnail" class="spinner">

                      <mat-spinner [diameter]="36"></mat-spinner>
                    </span>
                    <div class="empty-image-bg">
                      <img src="assets/img/IMAGE.svg" />
                      <!-- <img (load)="onLoadImg('backgroundThumbnail', $event)" (error)="onErrorImg('backgroundThumbnail', $event)" id="backgroundThumbnail" #backgroundThumbnail [src]="folderBackgroundAssetsUrl" alt="Aucune image" />-->
                    </div>
                    <mat-radio-group name="mediaStyle">
                      <mat-radio-button value="image" [checked]="mediaStyle == 'image'" (change)="setStyle('image')">
                      </mat-radio-button>
                    </mat-radio-group>

                  </div>
                  <p>{{'thumbnailSize' | translation}}</p>
                  <p>300x300px</p>
                </div>
                <div>
                  <mat-form-field appearance="fill">
                    <mat-label>{{'buttonSize' | translation}}</mat-label>
                    <mat-select (selectionChange)="changeButtonSize()" [(value)]="buttonSize">
                      <mat-option value="small">{{'small' | translation}}</mat-option>
                      <mat-option value="big">{{'big' | translation}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

            </div>

            <div>
              <div class="nav-title">
                <h1> Agencement média</h1>
              </div>
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout="column" fxLayoutAlign="center center" class="displayWrapper">
                  <div fxLayout="column" fxLayoutAlign="center center" class="image-upload-wrapper">
                    <h2>Défaut</h2>
                    <div class="empty-image-bg">
                      <img src="assets/img/FULL.svg" />
                    </div>
                    <mat-radio-group name="displayStyle">
                      <mat-radio-button value="default" [checked]="displayStyle == 'default'" (change)="setDisplayStyle('default')">
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="center center" class="displayWrapper">
                  <div fxLayout="column" fxLayoutAlign="center center" class="image-upload-wrapper">
                    <h2>GRID 2</h2>
                    <div class="empty-image-bg">
                      <img src="assets/img/FULL.svg" />
                    </div>
                    <mat-radio-group name="displayStyle">
                      <mat-radio-button value="grid2" [checked]="displayStyle == 'grid2'" (change)="setDisplayStyle('grid2')">
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="center center" class="displayWrapper">
                  <div fxLayout="column" fxLayoutAlign="center center" class="image-upload-wrapper">
                    <h2>GRID 3</h2>
                    <div class="empty-image-bg">
                      <img src="assets/img/FULL.svg" />
                    </div>
                    <mat-radio-group name="displayStyle">
                      <mat-radio-button value="grid3" [checked]="displayStyle == 'grid3'" (change)="setDisplayStyle('grid3')">
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="center center" class="displayWrapper">
                  <div fxLayout="column" fxLayoutAlign="center center" class="image-upload-wrapper">
                    <h2>GRID 4</h2>
                    <div class="empty-image-bg">
                      <img src="assets/img/FULL.svg" />
                    </div>
                    <mat-radio-group name="displayStyle">
                      <mat-radio-button value="grid4" [checked]="displayStyle == 'grid4'" (change)="setDisplayStyle('grid4')">
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="enableHeader != undefined" class="globalDesignElement">
              <p>{{'enableMediaHeader' | translation}}</p>
              <mat-slide-toggle color="accent" type="checkbox" [(ngModel)]="enableHeader" (ngModelChange)="setHeaderData()">
              </mat-slide-toggle>
              <p>(Media 1.17.18)</p>
            </div>
          </div>
        </mat-expansion-panel>
        <!-- ///////////////////////////////// -->
        <!-- INPUT FILE STYLING TESTS -->
        <!-- <div   fxLayout="column"  fxLayoutAlign="center center" class="image-upload-wrapper">
            <p>Icône du bouton</p>
            <div class="image-wrapper">
                <img class="image-src" [src]="thumbnail" alt="" />
                <p id="text-import" *ngIf="!thumbnail">Importer une image</p>

            </div>
            <button mat-mini-fab  >
                <mat-icon>edit</mat-icon>
                <input (change)="prepareForUpload($event, fileTarget)" type="file" [name]="fileTarget" />
            </button>
        </div> -->
        <!-- INPUT FILE STYLING TESTS -->
        <!-- ///////////////////////////////// -->
        <!-- CONTENUS -->
        <!-- <div fxLayout="row" fxLayoutAlign="start space-between">

          <div *ngIf="selectedFolder.id != undefined">
            <input type="file" (change)="uploadFolderAssets($event, 'thumbnail')" name="thumbnail" />
          </div>
          <div>
            <input (change)="uploadFolderAssets($event, 'background')" type="file" name="background" />
          </div>
        </div> -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{'contentMediaDesign' | translation}}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="homeElement">
            <div fxLayout="row wrap" fxLayoutAlign="start start">
              <div *ngIf="selectedFolder.id != undefined" fxLayout="column" fxLayoutAlign="flex-start center"
                   class="image-upload-wrapper">
                <h2>{{'buttonIcon' | translation}}</h2>

                <span *ngIf="!loadingThumbnail" class="spinner">
                  <mat-spinner [diameter]="36"></mat-spinner>
                </span>


                <div class="empty-image-bg">
                  <img (load)="onLoadImg('thumbnail', $event)" (error)="onErrorImg('thumbnail', $event)" id="thumbnail"
                       #thumbnail *ngIf="folderThumbnailAssetsUrl != undefined" [src]="folderThumbnailAssetsUrl"
                       alt="Aucune image" />
                </div>



                <input id="uploadThumbnail" type="file" (change)="upMediaThumbnail($event)" name="thumbnail" accept=".jpg,.png" />



                <button (click)="clickOnUpload('uploadThumbnail')" mat-mini-fab><mat-icon>edit</mat-icon></button>

              </div>

              <div fxLayout="column" fxLayoutAlign="center center" class="image-upload-wrapper">
                <h2>{{'backgroundImage' | translation}}</h2>
                <span *ngIf="!loadingBackgroundThumbnail" class="spinner">

                  <mat-spinner [diameter]="36"></mat-spinner>
                </span>

                <div class="empty-image-bg">
                  <img (load)="onLoadImg('backgroundThumbnail', $event)" (error)="onErrorImg('backgroundThumbnail', $event)"
                       id="backgroundThumbnail" #backgroundThumbnail [src]="folderBackgroundAssetsUrl" alt="Aucune image" />
                </div>


                <span fxLayout="row" fxLayoutAlign="space-evenly center" class="backgroundButtonContainer">
                  <span (click)="openColorSelection()" class="colorSelector" id="colorSelectorBackground" [ngStyle]="{'background-color': defaultBackgroundColor}">
                  </span>

                  <input id="uploadBackground" (change)="uploadFolderAssets($event, 'background', folderBackgroundAssetsUrl)" type="file" name="background" accept=".jpg,.png" />
                  <button mat-mini-fab (click)="clickOnUpload('uploadBackground')"><mat-icon>edit</mat-icon></button>
                  <button style="{z-index: 1;}" mat-mini-fab color="warn" (click)="removeBackground(folderBackgroundAssetsUrl)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </span>
              </div>



              <div *ngIf="selectedFolder.id == undefined" fxLayout="column" fxLayoutAlign="center center"
                   class="image-upload-wrapper">
                <h2>{{'mainLogo' | translation}}</h2>
                <span *ngIf="!loadingLogo" class="spinner">

                  <mat-spinner [diameter]="36"></mat-spinner>
                </span>

                <div class="empty-image-bg">
                  <img (load)="onLoadImg('logo', $event)" (error)="onErrorImg('logo', $event)" id="logo" #logo
                       [src]="logoUrl" alt="Aucune image" />
                </div>



                <span class="logoButtonContainer" fxLayout="row">
                  <input id="uploadLogo" (change)="uploadFolderAssets($event, 'logo')" type="file" name="logo" accept=".jpg,.png" />
                  <button (click)="clickOnUpload('uploadLogo')" mat-mini-fab><mat-icon>edit</mat-icon></button>
                  <button style="{z-index: 1;}" mat-mini-fab color="warn" (click)="removeLogo(logoUrl)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </span>
              </div>

            </div>

            <div *ngIf="excelUploadEnable.includes(_firebase.user.uid)">
              <!-- ORDRE DE MALTE CUSTOM UPLOAD EXCEL -->
              <h2>Charger fichier excel</h2>
              <input id="uploadExcel" (change)="managerExcelFile($event)" type="file" name="excel" accept=".xlsx" />
              <p *ngIf="excelData && excelData.latestUpdate">Dernière mise a jour: {{excelData.latestUpdate | date: 'medium'}}</p>
            </div>

          </div>
          <div>
            <div *ngIf="enableHeader != undefined" class="globalDesignElement">
              <p>{{'hideItemName' | translation}}</p>
              <mat-slide-toggle color="accent" type="checkbox" [(ngModel)]="hideElementName"  (ngModelChange)="setDisplayElementName()">
              </mat-slide-toggle>
              <p>(Media 1.17.32)</p>
            </div>
          </div>












        </mat-expansion-panel>
      </mat-accordion>
    </section>
















    <h1 class="section-title">{{'content' | translation}}</h1>



    <app-content-list #contentList
                      *ngIf="contentData"
                      [items]="contentArray"

                      [contentData]="contentData"
                      [(latestUpdate)]="latestUpdate"
                      [moduleId]="moduleId"
                      [selectedFolder]="selectedFolder"
                      (contentListEvent)="eventManager($event)"></app-content-list>


    <input type="file" #uploadMediaThumbnail (change)="upMediaThumbnail($event)" name="test" id="file"
           style="display:none;" />
    <!--

     <div class="containerElementWrapper" fxLayoutAlign="start start" style="flex-wrap:wrap;" cdkDropListGroup>



      <ng-container *ngFor="let item of contentArray; let i = index">

        <div cdkDropList [cdkDropListData]="i" (cdkDropListDropped)="drop($event)">

          <div [matMenuTriggerFor]="menuEditContent" fxLayoutAlign="center center" matRipple class="containerElement"
            [cdkDragData]="i" cdkDrag>



            <div fxLayoutAlign="center center" fxLayout="column">
              <mat-icon class="visibility-off" *ngIf="item.mediaOptions != undefined && !item.mediaOptions.active">
                nsvisibility_off
              </mat-icon>

              <h1 class="truncate" *ngIf="item.displayName">{{ item.displayName }}</h1>
              <h1 class="truncate" *ngIf="!item.displayName">{{ item.name }}</h1>
              <div style="width: fit-content !important;">
                <mat-icon>{{ item.type | typeIcon }}</mat-icon>
              </div>




              <div class="empty-image-bg">



                <p class="textNoPicture"
                  *ngIf="!getFileUrl(item) && (item.mediaOptions != undefined && !item.mediaOptions.thumbnail)">Aucun
                  aperçu</p>

                <div (error)="$event.target.display = 'none'" fxLayout="row wrap" class="content-image-wrapper"
                  *ngIf="item.mediaOptions != undefined && item.mediaOptions.thumbnail && item.type == 'folder'">
                  <img [src]="item.mediaOptions.thumbnail.url" [hidden]="!item.mediaOptions.thumbnail.url"
                    alt="Aucun aperçu" />
                </div>
                <div fxLayout="row w-100" class="content-image-wrapper"
                  *ngIf="item.mediaOptions != undefined  && (item.type == 'file' ||item.type == 'quiz')">
                  <img [src]="getFileUrl(item)" [hidden]="!getFileUrl(item)" alt="Aucun aperçu" />
                </div>
                <div fxLayout="row w-100" class="content-image-wrapper"
                  *ngIf="item.mediaOptions != undefined  && (item.type == 'web')">
                  <img [src]="getFileUrl(item)" [hidden]="!getFileUrl(item)" alt="Aucun aperçu" />
                </div>

              </div>

              <mat-menu #menuEditContent="matMenu">

                <button *ngIf="item.mediaOptions != undefined && item.mediaOptions.active"
                  (click)="setElementVisibility(item)" mat-menu-item>
                  <mat-icon>visibility_off</mat-icon>
                  Désactiver
                </button>
                <button *ngIf="item.mediaOptions != undefined && !item.mediaOptions.active"
                  (click)="setElementVisibility(item)" mat-menu-item>

                  <mat-icon>visibility_on</mat-icon>
                  Activer
                </button>


                <button *ngIf="item.mediaOptions != undefined && !item.mediaOptions.lock" (click)="setElementLock(item)"
                  mat-menu-item>
                  <mat-icon>lock</mat-icon>
                  Verrouiler
                </button>
                <button *ngIf="item.mediaOptions != undefined && item.mediaOptions.lock" (click)="setElementLock(item)"
                  mat-menu-item>
                  <mat-icon>lock_open</mat-icon>
                  Déverrouiller
                </button>


                <button mat-menu-item *ngIf="canAddThumbnail(item) || item.type =='quiz'"
                  (click)="uploadThumbnail(item)">
                  <mat-icon>image</mat-icon>
                  Ajouter une vignette
                </button>

                <button mat-menu-item (click)="manageTags(item)">
                  <mat-icon>folder</mat-icon>
                  Gérer les tags
                </button>

                <button mat-menu-item (click)="moveTo(item.id)">
                  <mat-icon>folder</mat-icon>
                  Déplacer vers
                </button>

                <button *ngIf="item.type != 'web'" mat-menu-item (click)="rename(item)">
                  <mat-icon>folder</mat-icon>
                  Renommer
                </button>

                <button mat-menu-item (click)="deleteMedia(item)">
                  <mat-icon color="warn">delete</mat-icon>
                  Supprimer
                </button>
              </mat-menu>
            </div>
            <mat-icon class="visibility-off lockIcon" *ngIf="item.mediaOptions != undefined && item.mediaOptions.lock">
              lock
            </mat-icon>






          </div>

        </div>
      </ng-container>


    </div>  -->
    <!-- ///////// -->


  </div>
</main>
